import {useMutation, useQueryClient} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../envisia/auth/axios-http-client';
import {environment} from '../../../environments/environment';
import {queryKey} from './multilayer-plan-query-keys';

interface Props {
  sharedId: string;
  onSuccess: () => void;
}

export function useMultilayerPlanDeleteMutation({sharedId, onSuccess}: Props) {
  const queryClient = useQueryClient();
  const {mutate, isPending} = useMutation({
    mutationFn: () =>
      AxiosHttpClient.delete(`${environment.apiv4uri}multilayerplan/${sharedId}`),
    onSuccess: async () => {
      queryClient.removeQueries({queryKey: queryKey.single(sharedId), exact: true});
      await queryClient.invalidateQueries({queryKey: queryKey.lists()});
      onSuccess();
    },
  });

  return {
    deleteMutation: () => mutate(),
    deleteIsPending: isPending,
  };
}
